var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleBtnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4285f4;}.cls-1,.cls-2,.cls-3,.cls-4{fillRule:evenodd;}.cls-2{fill:#34a853;}.cls-3{fill:#fbbc05;}.cls-4{fill:#ea4335;}.cls-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_googleg_48dp",
    "data-name": "logo googleg 48dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "M17.6,9.2a9.91,9.91,0,0,0-.2-1.8H9v3.5h4.8A4.12,4.12,0,0,1,12,13.6v2.3h3a9,9,0,0,0,2.6-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-2",
    d: "M9,18a8.67,8.67,0,0,0,6-2.2l-3-2.2a5.6,5.6,0,0,1-3,.9,5.38,5.38,0,0,1-5-3.7H1V13a8.8,8.8,0,0,0,8,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    className: "cls-3",
    d: "M4,10.7A4.67,4.67,0,0,1,3.7,9,4.67,4.67,0,0,1,4,7.3V5H1A9.1,9.1,0,0,0,0,9a7.92,7.92,0,0,0,1,4l3-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    className: "cls-4",
    d: "M9,3.6a5.13,5.13,0,0,1,3.4,1.3L15,2.3A8.74,8.74,0,0,0,9,0,8.8,8.8,0,0,0,1,5L4,7.3A5.38,5.38,0,0,1,9,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    className: "cls-5",
    d: "M0,0H18V18H0Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleBtnIcon);
export default __webpack_public_path__ + "static/media/google_btn_icon.81953659.svg";
export { ForwardRef as ReactComponent };